import React, { useEffect, useState } from "react";
import { renderPortableText } from "../../utils/sanityHelpers";
import "./style.scss";

function StepsHoverCard({
  items = [],
  title = "",
  imageKey = "image",
  titleKey = "label",
  descriptionKey = "details",
  animationSpeed = 1000,
  imageWidth = 105,
  imageHeight = 105,
}) {
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (items.length > 0) {
      const interval = setInterval(() => {
        setStep((prevStep) => (prevStep % items.length) + 1);
      }, animationSpeed);

      return () => clearInterval(interval);
    }
  }, [items, animationSpeed]);

  // Calculate specific percentages for each step transition
  const getFilledLineWidth = () => {
    switch (step) {
      case 1:
        return "0%";
      case 2:
        return "33%";
      case 3:
        return "65%";
      case 4:
        return "96%";
      default:
        return "0%";
    }
  };

  if (items.length === 0) {
    return null; // Or return a loading/empty state
  }

  return (
    <div className="steps-hc-wrap">
      <div className="horizontal-progress-bar mt-70">
        <div className="horizontal-line-wrap">
          <div className="horizontal-line"></div>
          <div
            className="horizontal-filled-line"
            style={{ width: getFilledLineWidth() }}
          ></div>
        </div>
        <div className="horizontal-step-wrap">
          {items.map((_, index) => (
            <div
              key={index}
              className={`horizontal-step ${
                step >= index + 1 ? "horizontal-filled" : ""
              }`}
            >
              {index + 1}
            </div>
          ))}
        </div>
      </div>
      <div className="steps-hc-container">
        {items.map((item, index) => (
          <div key={index} className="steps-hc-item">
            <div className="steps-hc-item-content">
              {item[imageKey] && (
                <div className="steps-hc-img">
                  <img
                    src={item[imageKey]}
                    alt={item[titleKey] || `Step ${index + 1}`}
                    width={item.imageWidth || imageWidth}
                    height={item.imageHeight || imageHeight}
                  />
                </div>
              )}
              {item[titleKey] && (
                <div className="steps-hc-title">{item[titleKey]}</div>
              )}
              {item[descriptionKey] && (
                <div className="steps-hc-description">
                  {typeof item[descriptionKey] === 'string' 
                    ? item[descriptionKey]
                    : renderPortableText(item[descriptionKey], 'steps-hc-text')
                  }
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StepsHoverCard;
